import React from "react";
import PropTypes from "prop-types";
import { Card, Tab, Row, Col, Nav, Button } from "react-bootstrap";
import FalconCardBody from "./FalconCardBody";
import classNames from "classnames";
import { HashLink } from "react-router-hash-link";
import Flex from "./Flex";
import { useLocation } from "react-router-dom";
import { camelize } from "../../helpers/utils";
import { useAppContext } from "providers/AppProvider";

const PreviewCode = () => {
  return (
    <Row className="d-inline-block">
      <Col>
        <Nav variant="pills" className="nav-pills-falcon m-0">
          <Nav.Item>
            <Nav.Link as={Button} size="sm" eventKey="preview">
              Preview
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Button} size="sm" eventKey="code">
              Code
            </Nav.Link>
          </Nav.Item>
          {/* <Button variant="" type="button" size="sm">
            Preview
          </Button>
          <Button variant="" type="button" size="sm">
            Code
          </Button> */}
        </Nav>
      </Col>
    </Row>
  );
};

const FalconComponentCardHeader = ({
  light,
  className,
  title,
  children,
  noPreview,
}) => {
  const location = useLocation();
  const {
    config: { isRTL },
  } = useAppContext();
  return (
    <Card.Header
      className={classNames({ "bg-body-tertiary  w-100  ": light }, className)}
    >
      {children}
    </Card.Header>
  );
};

const FalconComponentCard = ({
  children,
  multiSections,
  noGuttersBottom,
  tabContainerProps,
  ...rest
}) => {
  return (
    <Card className={classNames({ "mb-3": !noGuttersBottom })} {...rest}>
      {multiSections ? (
        children
      ) : (
        <Tab.Container defaultActiveKey="preview" {...tabContainerProps}>
          {children}
        </Tab.Container>
      )}
    </Card>
  );
};

FalconComponentCard.Header = FalconComponentCardHeader;
FalconComponentCard.Body = FalconCardBody;

FalconComponentCard.propTypes = {
  children: PropTypes.node,
  multiSections: PropTypes.bool,
  noGuttersBottom: PropTypes.bool,
};

FalconComponentCardHeader.propTypes = {
  light: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  noPreview: PropTypes.bool,
};

export default FalconComponentCard;
